import { FallbackErrorBoundary } from "@/components/FallbackErrorBoundary";
import { SectionItemEmptyState } from "@/features/tasks/SectionItem";
import { UpcomingAppointmentItem } from "@/features/tasks/UpcomingAppointmentItem";
import { ListView } from "@repo/skapa";
import { t } from "@repo/translation";
import { hasItems } from "@repo/utils";

import { useGrouppedAppointments } from "./useGrouppedAppointments";

interface CompletedAppointmentsProps {
  opportunityId: number;
  editable?: boolean;
}

export const CompletedAppointments = ({
  opportunityId,
  editable,
}: CompletedAppointmentsProps) => {
  const { completed } = useGrouppedAppointments(opportunityId);

  // Newest completed appointments first
  const sorted = [...completed].sort((a, b) =>
    b.timeWindowStartTime.localeCompare(a.timeWindowStartTime)
  );

  if (!hasItems(sorted)) {
    return <SectionItemEmptyState title={t("prompt.no_appointments")} />;
  }

  return (
    <ListView id="completed-appointments-list">
      {sorted.map((appointment, index) => (
        <FallbackErrorBoundary
          key={appointment.id}
          errorMessage={`Failed to render appointment: ${appointment.id}`}
        >
          <UpcomingAppointmentItem
            editable={editable}
            first={index === 0}
            last={index === sorted.length - 1}
            appointment={appointment}
            projectId={opportunityId}
          />
        </FallbackErrorBoundary>
      ))}
    </ListView>
  );
};
